// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file gov_geo_access.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Organization, OrganizationJson } from "./organization_pb";
import { file_organization } from "./organization_pb";
import type { PickupLocation, PickupLocationJson } from "./pickup_location_pb";
import { file_pickup_location } from "./pickup_location_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file gov_geo_access.proto.
 */
export const file_gov_geo_access: GenFile = /*@__PURE__*/
  fileDesc("ChRnb3ZfZ2VvX2FjY2Vzcy5wcm90bxIJcmFjY29vbmFpIpsECgxHb3ZHZW9BY2Nlc3MSCgoCaWQYASACKAQSHAoJYXJlYV9uYW1lGAIgAigJUglhcmVhX25hbWUSKAoPb3JnYW5pemF0aW9uX2lkGAMgAigEUg9vcmdhbml6YXRpb25faWQSRQoRc2VydmljZV9wcm92aWRlcnMYBCADKAsyFy5yYWNjb29uYWkuT3JnYW5pemF0aW9uUhFzZXJ2aWNlX3Byb3ZpZGVycxJFChBwaWNrdXBfbG9jYXRpb25zGAUgAygLMhkucmFjY29vbmFpLlBpY2t1cExvY2F0aW9uUhBwaWNrdXBfbG9jYXRpb25zEj8KDmRpc3Bvc2FsX3NpdGVzGAYgAygLMhcucmFjY29vbmFpLk9yZ2FuaXphdGlvblIOZGlzcG9zYWxfc2l0ZXMSKQoIZ2VvbWV0cnkYByABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0EjoKCmNyZWF0ZWRfYXQYCCACKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgpjcmVhdGVkX2F0EjoKCnVwZGF0ZWRfYXQYCSACKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgp1cGRhdGVkX2F0EkUKEXNlcnZpY2VfcmVjZWl2ZXJzGAogAygLMhcucmFjY29vbmFpLk9yZ2FuaXphdGlvblIRc2VydmljZV9yZWNlaXZlcnMiVwoQR292R2VvQWNjZXNzTGlzdBJDChBnb3ZfZ2VvX2FjY2Vzc2VzGAEgAygLMhcucmFjY29vbmFpLkdvdkdlb0FjY2Vzc1IQZ292X2dlb19hY2Nlc3NlcyKHAQoSR292R2VvQWNjZXNzQ3JlYXRlEhwKCWFyZWFfbmFtZRgBIAIoCVIJYXJlYV9uYW1lEigKD29yZ2FuaXphdGlvbl9pZBgCIAIoBFIPb3JnYW5pemF0aW9uX2lkEikKCGdlb21ldHJ5GAMgASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdCKGBAoSR292R2VvQWNjZXNzVXBkYXRlEgoKAmlkGAEgAigEEhwKCWFyZWFfbmFtZRgCIAIoCVIJYXJlYV9uYW1lEigKD29yZ2FuaXphdGlvbl9pZBgDIAIoBFIPb3JnYW5pemF0aW9uX2lkEkUKEXNlcnZpY2VfcHJvdmlkZXJzGAQgAygLMhcucmFjY29vbmFpLk9yZ2FuaXphdGlvblIRc2VydmljZV9wcm92aWRlcnMSRQoQcGlja3VwX2xvY2F0aW9ucxgFIAMoCzIZLnJhY2Nvb25haS5QaWNrdXBMb2NhdGlvblIQcGlja3VwX2xvY2F0aW9ucxI/Cg5kaXNwb3NhbF9zaXRlcxgGIAMoCzIXLnJhY2Nvb25haS5Pcmdhbml6YXRpb25SDmRpc3Bvc2FsX3NpdGVzEikKCGdlb21ldHJ5GAcgASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdBI6CgpjcmVhdGVkX2F0GAggAigLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFIKY3JlYXRlZF9hdBI6Cgp1cGRhdGVkX2F0GAkgAigLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFIKdXBkYXRlZF9hdBIqCglyZWNlaXZlcnMYCiADKAsyFy5yYWNjb29uYWkuT3JnYW5pemF0aW9uInoKHkdvdkdlb0FjY2Vzc0Fzc29jaWF0aW9uUmVxdWVzdBIsChFnb3ZfZ2VvX2FjY2Vzc19pZBgBIAIoBFIRZ292X2dlb19hY2Nlc3NfaWQSKgoQb3JnYW5pemF0aW9uX2lkcxgCIAMoBFIQb3JnYW5pemF0aW9uX2lkc0IGWgQuL3Bi", [file_google_protobuf_struct, file_google_protobuf_timestamp, file_organization, file_pickup_location]);

/**
 * @generated from message raccoonai.GovGeoAccess
 */
export type GovGeoAccess = Message<"raccoonai.GovGeoAccess"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required string area_name = 2 [json_name = "area_name"];
   */
  areaName: string;

  /**
   * @generated from field: required uint64 organization_id = 3 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: repeated raccoonai.Organization service_providers = 4 [json_name = "service_providers"];
   */
  serviceProviders: Organization[];

  /**
   * @generated from field: repeated raccoonai.PickupLocation pickup_locations = 5 [json_name = "pickup_locations"];
   */
  pickupLocations: PickupLocation[];

  /**
   * @generated from field: repeated raccoonai.Organization disposal_sites = 6 [json_name = "disposal_sites"];
   */
  disposalSites: Organization[];

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 7;
   */
  geometry?: JsonObject;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 8 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 9 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: repeated raccoonai.Organization service_receivers = 10 [json_name = "service_receivers"];
   */
  serviceReceivers: Organization[];
};

/**
 * @generated from message raccoonai.GovGeoAccess
 */
export type GovGeoAccessJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required string area_name = 2 [json_name = "area_name"];
   */
  area_name?: string;

  /**
   * @generated from field: required uint64 organization_id = 3 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: repeated raccoonai.Organization service_providers = 4 [json_name = "service_providers"];
   */
  service_providers?: OrganizationJson[];

  /**
   * @generated from field: repeated raccoonai.PickupLocation pickup_locations = 5 [json_name = "pickup_locations"];
   */
  pickup_locations?: PickupLocationJson[];

  /**
   * @generated from field: repeated raccoonai.Organization disposal_sites = 6 [json_name = "disposal_sites"];
   */
  disposal_sites?: OrganizationJson[];

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 7;
   */
  geometry?: StructJson;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 8 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 9 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;

  /**
   * @generated from field: repeated raccoonai.Organization service_receivers = 10 [json_name = "service_receivers"];
   */
  service_receivers?: OrganizationJson[];
};

/**
 * Describes the message raccoonai.GovGeoAccess.
 * Use `create(GovGeoAccessSchema)` to create a new message.
 */
export const GovGeoAccessSchema: GenMessage<GovGeoAccess, {jsonType: GovGeoAccessJson}> = /*@__PURE__*/
  messageDesc(file_gov_geo_access, 0);

/**
 * @generated from message raccoonai.GovGeoAccessList
 */
export type GovGeoAccessList = Message<"raccoonai.GovGeoAccessList"> & {
  /**
   * @generated from field: repeated raccoonai.GovGeoAccess gov_geo_accesses = 1 [json_name = "gov_geo_accesses"];
   */
  govGeoAccesses: GovGeoAccess[];
};

/**
 * @generated from message raccoonai.GovGeoAccessList
 */
export type GovGeoAccessListJson = {
  /**
   * @generated from field: repeated raccoonai.GovGeoAccess gov_geo_accesses = 1 [json_name = "gov_geo_accesses"];
   */
  gov_geo_accesses?: GovGeoAccessJson[];
};

/**
 * Describes the message raccoonai.GovGeoAccessList.
 * Use `create(GovGeoAccessListSchema)` to create a new message.
 */
export const GovGeoAccessListSchema: GenMessage<GovGeoAccessList, {jsonType: GovGeoAccessListJson}> = /*@__PURE__*/
  messageDesc(file_gov_geo_access, 1);

/**
 * @generated from message raccoonai.GovGeoAccessCreate
 */
export type GovGeoAccessCreate = Message<"raccoonai.GovGeoAccessCreate"> & {
  /**
   * @generated from field: required string area_name = 1 [json_name = "area_name"];
   */
  areaName: string;

  /**
   * @generated from field: required uint64 organization_id = 2 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 3;
   */
  geometry?: JsonObject;
};

/**
 * @generated from message raccoonai.GovGeoAccessCreate
 */
export type GovGeoAccessCreateJson = {
  /**
   * @generated from field: required string area_name = 1 [json_name = "area_name"];
   */
  area_name?: string;

  /**
   * @generated from field: required uint64 organization_id = 2 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 3;
   */
  geometry?: StructJson;
};

/**
 * Describes the message raccoonai.GovGeoAccessCreate.
 * Use `create(GovGeoAccessCreateSchema)` to create a new message.
 */
export const GovGeoAccessCreateSchema: GenMessage<GovGeoAccessCreate, {jsonType: GovGeoAccessCreateJson}> = /*@__PURE__*/
  messageDesc(file_gov_geo_access, 2);

/**
 * @generated from message raccoonai.GovGeoAccessUpdate
 */
export type GovGeoAccessUpdate = Message<"raccoonai.GovGeoAccessUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required string area_name = 2 [json_name = "area_name"];
   */
  areaName: string;

  /**
   * @generated from field: required uint64 organization_id = 3 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: repeated raccoonai.Organization service_providers = 4 [json_name = "service_providers"];
   */
  serviceProviders: Organization[];

  /**
   * @generated from field: repeated raccoonai.PickupLocation pickup_locations = 5 [json_name = "pickup_locations"];
   */
  pickupLocations: PickupLocation[];

  /**
   * @generated from field: repeated raccoonai.Organization disposal_sites = 6 [json_name = "disposal_sites"];
   */
  disposalSites: Organization[];

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 7;
   */
  geometry?: JsonObject;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 8 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 9 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: repeated raccoonai.Organization receivers = 10;
   */
  receivers: Organization[];
};

/**
 * @generated from message raccoonai.GovGeoAccessUpdate
 */
export type GovGeoAccessUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required string area_name = 2 [json_name = "area_name"];
   */
  area_name?: string;

  /**
   * @generated from field: required uint64 organization_id = 3 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: repeated raccoonai.Organization service_providers = 4 [json_name = "service_providers"];
   */
  service_providers?: OrganizationJson[];

  /**
   * @generated from field: repeated raccoonai.PickupLocation pickup_locations = 5 [json_name = "pickup_locations"];
   */
  pickup_locations?: PickupLocationJson[];

  /**
   * @generated from field: repeated raccoonai.Organization disposal_sites = 6 [json_name = "disposal_sites"];
   */
  disposal_sites?: OrganizationJson[];

  /**
   * @generated from field: optional google.protobuf.Struct geometry = 7;
   */
  geometry?: StructJson;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 8 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 9 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;

  /**
   * @generated from field: repeated raccoonai.Organization receivers = 10;
   */
  receivers?: OrganizationJson[];
};

/**
 * Describes the message raccoonai.GovGeoAccessUpdate.
 * Use `create(GovGeoAccessUpdateSchema)` to create a new message.
 */
export const GovGeoAccessUpdateSchema: GenMessage<GovGeoAccessUpdate, {jsonType: GovGeoAccessUpdateJson}> = /*@__PURE__*/
  messageDesc(file_gov_geo_access, 3);

/**
 * @generated from message raccoonai.GovGeoAccessAssociationRequest
 */
export type GovGeoAccessAssociationRequest = Message<"raccoonai.GovGeoAccessAssociationRequest"> & {
  /**
   * @generated from field: required uint64 gov_geo_access_id = 1 [json_name = "gov_geo_access_id"];
   */
  govGeoAccessId: bigint;

  /**
   * @generated from field: repeated uint64 organization_ids = 2 [json_name = "organization_ids"];
   */
  organizationIds: bigint[];
};

/**
 * @generated from message raccoonai.GovGeoAccessAssociationRequest
 */
export type GovGeoAccessAssociationRequestJson = {
  /**
   * @generated from field: required uint64 gov_geo_access_id = 1 [json_name = "gov_geo_access_id"];
   */
  gov_geo_access_id?: string;

  /**
   * @generated from field: repeated uint64 organization_ids = 2 [json_name = "organization_ids"];
   */
  organization_ids?: string[];
};

/**
 * Describes the message raccoonai.GovGeoAccessAssociationRequest.
 * Use `create(GovGeoAccessAssociationRequestSchema)` to create a new message.
 */
export const GovGeoAccessAssociationRequestSchema: GenMessage<GovGeoAccessAssociationRequest, {jsonType: GovGeoAccessAssociationRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_geo_access, 4);

